import api from './index'
import { axios } from '@/utils/request'

export function createCategory(parameter) {
  return axios({
    url: api.BaseURL + api.Category+ 'create',
    method: 'POST',
    data: parameter
  })
}

export function getListCategory(parameter) {
  return axios({
    url: api.BaseURL + api.Category+ 'list',
    method: 'GET',
    params: parameter
  })
}

export function updateCategory(parameter) {
  return axios({
    url: api.BaseURL + api.Category+ 'update',
    method: 'POST',
    data: parameter
  })
}

export function deleteCategory(parameter) {
  return axios({
    url: api.BaseURL + api.Category+ 'delete',
    method: 'POST',
    data: parameter
  })
}